import { ITitle } from '../../../../forms/base/controls/content/Title';
import { RPDF } from '../../../react-pdf';

export const Title: ITitle = ({ text }) => {
  return (
    <RPDF.Text minPresenceAhead={1} style={{ ...RPDF.typography.heading5b, paddingVertical: 4, flexShrink: 0 }}>
      {text}
    </RPDF.Text>
  );
};
